import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
	const { t } = useTranslation();

	return (
		<Stack pt={5}>
			<Typography variant="h1" textAlign="center">
				{t('404')}
			</Typography>
		</Stack>
	);
};

export default NotFound;
